import React, { useEffect } from 'react'
import { images } from '../../constants'
import './Contact.css'
import { Nav } from '../../components'
import { Footer } from '../../containers'
import { motion } from 'framer-motion'
import { Helmet } from 'react-helmet'
import 'ol/ol.css'
import { Map, View } from 'ol'
import TileLayer from 'ol/layer/Tile'
import { XYZ } from 'ol/source'
import OSM from 'ol/source/OSM'
import { fromLonLat, toLonLat } from 'ol/proj'
import { Feature } from 'ol'
import { Point } from 'ol/geom'
import { Icon, Style } from 'ol/style'
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'

const Contact = () => {
  const imageAnimate = {
    offscreen: { x: 100, opacity: 0 },
    onscreen: {
      x: 0,
      opacity: 1,
      rotate: [0, 10, 0],
      transition: { type: 'spring', bounce: 0.4, duration: 1 },
    },
  }
  const textAnimate = {
    offscreen: { y: 50, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.4, duration: 2 },
    },
  }

  // Coordinates for the marker (longitude, latitude)
  const markerCoords = [174.7319, -36.8549]
  const googleMapsUrl = `https://www.google.com/maps/place/Sushi+Edge/@-36.8549137,174.7269806,17z/data=!3m1!4b1!4m6!3m5!1s0x6d0d4775ec974f7b:0x205e34a5ca9f65a5!8m2!3d-36.8549181!4d174.7318515!16s%2Fg%2F11b6ybc5_w?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D`

  useEffect(() => {
    // Create the OpenLayers map
    const map = new Map({
      target: 'map',
      layers: [
        // Add OpenStreetMap tile layer
        new TileLayer({
          source: new OSM({
            url: 'https://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
          }),
        }),
        // Add vector layer for the marker
        new VectorLayer({
          source: new VectorSource({
            features: [
              // Create the marker feature with a point geometry
              new Feature({
                geometry: new Point(fromLonLat([174.7319, -36.8549])), // Coordinates for the marker
              }),
            ],
          }),
          style: new Style({
            image: new Icon({
              src: images.map,
              scale: 1, // Scale the icon to your liking
            }),
          }),
        }),
      ],
      view: new View({
        center: fromLonLat([174.7319, -36.8549]),
        zoom: 15,
      }),
    })

    map.on('click', function (evt) {
      // Get the coordinates of the clicked point
      const clickedCoords = toLonLat(evt.coordinate)

      // Calculate if the clicked point is close enough to the marker
      const distance = Math.sqrt(
        Math.pow(clickedCoords[0] - markerCoords[0], 2) +
          Math.pow(clickedCoords[1] - markerCoords[1], 2)
      )

      if (distance < 0.001) {
        // If the click is near the marker, open the Google Maps link
        window.open(googleMapsUrl, '_blank')
      }
    })
    // Cleanup map on unmount
    return () => {
      map.setTarget(null)
    }
  }, [])
  return (
    <div>
      <Helmet>
        <title>Contact Us - Sushi Edge</title>
      </Helmet>
      <div className="container-xxl">
        <Nav />
      </div>
      <motion.div
        className="contact-container p-5"
        initial={'offscreen'}
        whileInView={'onscreen'}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ staggerChildren: 0.8 }}
      >
        <div className="row justify-content-center align-items-center">
          <motion.div
            className="col-md-6"
            variants={textAnimate}
          >
            <h1 className="text-light mt-5 mb-5">Visit Us</h1>
            <div className="text-light mb-5">
              <div className="d-flex gap-2">
                <i
                  className="ph-fill ph-map-pin"
                  style={{ fontSize: 40 }}
                ></i>
                <div>
                  <h5>Location: </h5>
                  <p>
                    6B/280 Richmond Road, <br />
                    Grey Lynn, Auckland 1021
                  </p>
                </div>
              </div>
              <div className="d-flex gap-2">
                <i
                  className="ph-fill ph-clock"
                  style={{ fontSize: 40 }}
                ></i>
                <div>
                  <h5>Hours: </h5>
                  <p>Monday to Sunday 8:30am - 7:00pm</p>
                </div>
              </div>
              <div className="d-flex gap-2">
                <i
                  className="ph-fill ph-user-circle"
                  style={{ fontSize: 40 }}
                ></i>
                <div>
                  <h5>Contacts: </h5>
                  <a href="mailto:liuping6909@gmail.com">
                    liuping6909@gmail.com
                  </a>
                  <p>09 376 6218</p>
                </div>
              </div>
            </div>
          </motion.div>
          {/* Map Container */}
          <motion.div
            className="col-md-6 mb-5"
            id="map"
            variants={imageAnimate}
          ></motion.div>
        </div>
      </motion.div>
      <div className="container-xxl mt-5">
        <Footer />
      </div>
    </div>
  )
}

export default Contact
